export enum FormType {
	Normal = 0,
	OnStep = 1,
  ExternalForm = 2,
  All = 1000, //For UX
}